<template>
  <div>
    <div class="artmag_top_bar">
      <span class="artmag_tip artmag_tip_noac" @click="goTome">个人中心</span>
      <i class="el-icon-arrow-right"></i>
      <span class="artmag_tip" @click="artmag">文章管理</span>
    </div>

    <div style="margin-top: 20px; display: flex; align-items: center">
      <div class="artmag_line_con">
        <span class="artmag_txt_label">文章标题：</span>
        <div>
          <el-input v-model="articleName" placeholder="请输入文章标题" />
        </div>
      </div>

      <div class="artmag_line_con" style="margin-left: 30px">
        <span class="artmag_txt_label">选择分类：</span>
        <el-select v-model="firstLevelClassId" @change="changeFirstLevelClass">
          <el-option
            v-for="item in firstLevelClass"
            :key="item.sortId"
            :value="item.sortId"
            :label="item.sortName"
          />
        </el-select>

        <el-select v-model="secondLevelClassId" style="margin-left: 10px">
          <el-option
            v-for="item in secondLevelClass"
            :key="item.sortId"
            :value="item.sortId"
            :label="item.sortName"
          />
        </el-select>
      </div>

      <div class="artmag_line_con" style="margin-left: 30px">
        <span
          class="artmag_txt_label"
          style="display: flex; align-items: center"
          >选择标签：</span
        >
        <el-select multiple name="labels" v-model="labelListForSearch">
          <el-option
            v-for="item in labelList"
            :key="item.labelName"
            :value="item.labelName"
            :label="item.labelName"
          />
        </el-select>
      </div>

      <div class="artmag_line_con" style="margin-left: 30px">
        <span class="artmag_txt_label">来源：</span>
        <el-select v-model="source">
          <el-option
            v-for="(item, index) in sourceList"
            :key="index"
            :value="item"
          >
            {{ item }}
          </el-option>
        </el-select>
      </div>
    </div>

    <div style="display: flex; align-items: center; margin-top: 20px">
      <div class="artmag_line_con">
        <span class="artmag_txt_label">发布时间：</span>
        <div class="artmag_add_in_con1">
          <el-date-picker
            v-model="publishTime"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['12:00:00']"
            style="border: solid 2px #0187ea"
          >
          </el-date-picker>
        </div>
      </div>

      <div class="artmag_line_con" style="margin-left: 220px">
        <span class="artmag_txt_label">收藏时间：</span>
        <div class="artmag_add_in_con1">
          <el-date-picker
            v-model="collectTime"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['12:00:00']"
            style="border: solid 2px #0187ea"
          >
          </el-date-picker>
        </div>

        <button class="artmag_start_col_btn" @click="searchArt">搜索</button>
      </div>
    </div>

    <div class="artmag_bgcon">
      <div class="artmag_tp_con"></div>
      <div>
        <div
          class="artmag_artitem"
          v-for="art in renderArtList"
          @click="detail(art.articleId)"
        >
          <div class="artmag_artitem_con">
            {{ art.articleTitle }}
          </div>
          <div class="artmag_artitem_infor">
            <div class="artmag_artitem_infor_left">
              <span class="artmag_artitem_infor_sou">{{ art.source }}</span>
              <span class="artmag_artitem_infor_time">{{
                art.updateTime
              }}</span>
              <span
                class="artmag_artitem_infor_tags"
                v-for="tag in art.kpArticleLabels"
              >
                <span class="artmag_artitem_infor_tag">
                  {{ tag.labelName }}
                </span>
              </span>
            </div>
            <div class="artmag_artitem_infor_right">
              <div
                class="artmag_artitem_btn_detail_out"
                @click="detail(art.articleId)"
              >
                <div class="artmag_artitem_btn_detail_in">详情</div>
              </div>
              <div
                class="artmag_artitem_btn_share_out"
                @click.stop="
                  share(
                    art.articleId,
                    art.articleTitle,
                    art.source,
                    art.kpArticleLabels,
                    art.createTime
                  )
                "
              >
                <div class="artmag_artitem_btn_share_in">分享</div>
              </div>
              <div class="artmag_artitem_btn_export_out">
                <div
                  v-if="art.source === '本地上传'"
                  class="artmag_artitem_btn_export_in"
                  @click.stop="exportFileLocal(art.articleId, art.source, art.articleTitle)"
                >
                  导出
                </div>
                <div
                  v-else
                  class="artmag_artitem_btn_export_in"
                  @click.stop="exportFile(art.articleId, art.source, art.articleTitle)"
                >
                  导出
                </div>
              </div>
              <div class="artmag_artitem_btn_del_out">
                <div
                  class="artmag_artitem_btn_del_in"
                  @click.stop="deleteArt(art.articleId)"
                >
                  删除
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-pagination
            :page-size="pageSize"
            :pager-count="pageCount"
            layout="prev, pager, next, jumper"
            :current-page="currentPage"
            @current-change="currentPageChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 分享选项弹窗 -->
      <div v-if="showShareOptionsModal" class="share-options-modal">
        <div class="share-option" @click="shareWithFriends">分享给好友</div>
        <div
          class="share-option"
          @click="
            () =>
              copyShareLink(
                currentArticleId,
                currentSource,
                currentLabels,
                currentCreateTime
              )
          "
        >
          分享链接
        </div>
        <div class="share-option" @click="closeShareOptionsModal">取消</div>
      </div>

      <!-- 好友列表弹窗 -->

      <div v-if="showFriendsListModal" class="friends-list-modal">
        <div class="list-section">
          <div class="section-title">好友</div>
          <div class="list-container">
            <div
              v-for="friend in friendsList"
              :key="friend.userId"
              class="friend-item"
            >
              <input
                type="checkbox"
                :value="friend"
                v-model="selectedFriends"
              />
              <!-- 添加选择框 -->
              <img class="fri_img" :src="friend.imageUrl" />
              <span class="friend_name">{{ friend.userName }}</span>
              <button @click="sendLinkToFriend(friend)">分享</button>
            </div>
          </div>
        </div>
        <!-- 群聊列表部分 -->
        <div class="list-section">
          <div class="section-title">团队</div>
          <div class="list-container">
            <div
              v-for="group in groupList"
              :key="group.groupId"
              class="friend-item"
            >
              <input type="checkbox" :value="group" v-model="selectedGroups" />
              <!-- 添加选择框 -->
              <span class="friend_name">{{ group.groupName }}</span>
              <button @click="sendLinkToGroup(group)">分享</button>
            </div>
          </div>
        </div>
        <!-- 最后再改这个一键分享 -->
        <!-- Container for action buttons -->
        <div class="friends-list-modal-actions">
          <button
            class="shareWithSelectedFriends"
            @click="shareWithSelectedFriends"
          >
            一键分享
          </button>
          <!-- One-click share button -->
          <div class="close-option" @click="closeFriendsListModal">取消</div>
          <!-- Cancel option -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { url } from "../api/request";
import {
  selectArticles,
  selectSourcesByUserId,
  GetFirstLevelClassification,
  GetSecondLevelClassification,
  getAllTag,
  exportToLocalPdf,
  exportToLocal,
  deleteArticle,
  articleInfo,
  getInfoByArticleId,
} from "@/api/article";
import { getTmpGroupList } from "@/api/chat";
import { GetFriendList, getFriendsByUseridAndKey } from "@/api/friend";
import { insertShareHistroy, findAllShareHistroy } from "@/api/shareHistory";
import {
  sendMessageInShare,
  sendGroupMessageInShare,
  sendSingleArticleMessage,
  sendGroupArticleMessage,
} from "../api/ws";
import { whoami } from "@/api/login";

export default {
  name: "artdetail",
  data() {
    return {
      tag: "",
      publishTime: "",
      collectTime: "",
      tpList: [],
      curSes: 0,
      artList: [],
      articleName: "",
      labelList: [],
      labelListForSearch: [],
      firstLevelClass: [],
      firstLevelClassId: "",
      firstLevelClassId1: "",
      allSecondLevelClass: [],
      secondLevelClass: [],
      sourceList: ["全部"],
      source: "全部",
      source1: "",
      secondLevelClassId: "",
      secondLevelClassId1: "",
      userId: 1,
      content: "",
      showShareOptionsModal: false, // 控制分享选项弹窗的显示
      showFriendsListModal: false, // 控制好友列表弹窗的显示
      selectedFriends: [], // 用于跟踪选中的好友
      currentArticleId: 0,
      currentSource: "",
      currentLabels: "",
      currentCreateTime: "",
      currentShareUserId: 1,
      friendsList: [],
      renderArtList: [],
      /* 群聊 */
      groupList: [],
      selectedGroups: [],
      currentArticleTitle: "",
      shareUrl: url + "/#/home/artdetail?aid=",
      pageSize: 10,
      pageCount: 1,
      total: 0,
      currentPage: 1,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    articleInfo() {
      return this.$store.getters.getArticleInfo;
    },
    collectionProcessStatus() {
      return this.collectionProcess == 100 ? "success" : "warning";
    },
  },
  created() {
    if (this.$store.state.msgContent.group.length == 0) {
      this.searchGroups();
    }
    whoami({}).then((res) => {
      this.userId = res.data.userId;
    });
  },
  mounted() {
    let that = this;
    getAllTag({
      userId: this.userInfo.id,
    }).then((res) => {
      console.log(res.data);
      this.labelList = res.data;
    });
    // 创建一个包含两个 promise 的数组
    Promise.all([
      GetFirstLevelClassification({
        userId: this.userInfo.id,
      }),
      GetSecondLevelClassification({
        userId: this.userInfo.id,
      }),
      selectSourcesByUserId({
        userId: this.userInfo.id,
      }),
    ])
      .then((responses) => {
        // 处理 GetFirstLevelClassification 的结果
        that.firstLevelClass.splice(0, that.firstLevelClass.length);
        that.firstLevelClassId = "-1";
        that.firstLevelClass.push({
          parentId: "-1",
          sortId: "-1",
          sortName: "全部",
          userId: that.userInfo.id,
        });
        responses[0].data.forEach((item) => {
          that.firstLevelClass.push(item);
          that.tpList.push(item);
        });
        console.log("firstLevelClass:", that.firstLevelClass);
        console.log("response:", responses);
        console.log(responses[0].data);
        console.log(that.tpList);

        selectArticles({
          userId: this.userInfo.id,
          publishTime: [],
          collectTime: [],
          sortIds: ["", ""],
          source: "",
          articleName: "",
        }).then((res) => {
          console.log("传过来的文章信息");
          console.log(res.data);
          that.artList = res.data;
          that.total = res.data.length;
          that.pageCount = Math.ceil(that.total / that.pageSize);
          that.renderArtList = res.data.slice(0, that.pageSize);
        });

        // 处理 GetSecondLevelClassification 的结果
        that.allSecondLevelClass.splice(0, that.secondLevelClass.length);
        that.secondLevelClassId = "";

        responses[1].data.forEach((item) => {
          that.allSecondLevelClass.push(item);
        });

        responses[2].data.forEach((item) => {
          that.sourceList.push(item);
        });

        if (that.articleInfo.ing) {
          // 根据一级分类处理二级分类
          const arr = that.allSecondLevelClass.filter((item) => {
            return item.parentId == that.articleInfo.firstLevelClassId;
          });
          arr.forEach((item) => {
            that.secondLevelClass.push(item);
          });

          // 将this.articleInfo赋值到页面data
          for (let key in that.articleInfo) {
            that[key] = that.articleInfo[key];
          }
        }
      })
      .catch((error) => {
        // 处理任一 promise 出错的情况
        console.error("Error in one of the promises:", error);
      });
  },
  methods: {
    artmag() {
      var that = this;

      that.$router.push({
        name: "artmag",
        params: {
          refresh: true,
        },
      });
    },
    currentPageChange(val) {
      console.log(val);
      this.currentPage = val;
      this.renderArtList = this.artList.slice(
        (val - 1) * this.pageSize,
        val * this.pageSize
      );
    },
    goTome() {
      this.$router.push({
        name: "me",
      });
    },
    searchArt() {
      if (this.source == "全部") {
        this.source1 = "";
      } else {
        this.source1 = this.source;
      }
      if (this.firstLevelClassId == "-1") {
        this.firstLevelClassId1 = "";
      } else {
        this.firstLevelClassId1 = this.firstLevelClassId;
      }
      if (this.secondLevelClassId == "-1") {
        this.secondLevelClassId1 = "";
      } else {
        this.secondLevelClassId1 = this.secondLevelClassId;
      }
      selectArticles({
        userId: this.userInfo.id,
        publishTime: this.publishTime || [],
        collectTime: this.collectTime || [],
        sortIds: [this.firstLevelClassId1, this.secondLevelClassId1],
        labelNames: this.labelListForSearch,
        source: this.source1,
        articleName: this.articleName,
      })
        .then((response) => {
          console.log("Search Response:", response);
          this.artList = response.data;
          this.total = response.data.length;
          this.pageCount = Math.ceil(this.total / this.pageSize);
          this.renderArtList = response.data.slice(0, this.pageSize);
        })
        .catch((error) => {
          // 处理任一 promise 出错的情况
          console.error("Error in one of the promises:", error);
        });
    },
    tpses(index) {
      this.curSes = index;
      var that = this;
      selectArticles({
        userId: this.userInfo.id,
        publishTime: [],
        collectTime: [],
        sortIds: ["", ""],
        source: "",
        articleName: "",
      }).then((res) => {
        that.artList = res.data;
        console.log(that.artList);
      });
    },
    changeFirstLevelClass() {
      this.secondLevelClass.splice(0, this.secondLevelClass.length);
      console.log(this.firstLevelClassId);
      if (this.firstLevelClassId == "-1") {
        this.firstLevelClassId1 = "";
      } else {
        this.firstLevelClassId1 = this.firstLevelClassId;
      }
      console.log("this.firstLevelClassId1:", this.firstLevelClassId1);
      const arr = this.allSecondLevelClass.filter(
        (item) => item.parentId == this.firstLevelClassId1
      );
      this.secondLevelClass.push({
        parentId: this.firstLevelClassId1,
        sortId: "-1",
        sortName: "全部",
        userId: this.userInfo.id,
      });
      arr.forEach((item) => {
        this.secondLevelClass.push(item);
      });
      console.log("this.secondLevelClass:", this.secondLevelClass);
    },
    detail(articleId) {
      this.$router.push({
        name: "artdetail",
        query: {
          aid: articleId,
        },
      });
    },

    share(
      articleId,
      articleTitle,
      currentSource,
      currentLabels,
      currentCreateTime
    ) {
      this.currentArticleId = articleId;
      // 保存当前文章ID
      this.currentSource = currentSource;
      this.currentLabels = currentLabels;
      this.currentCreateTime = currentCreateTime;
      this.currentArticleTitle = articleTitle;
      getInfoByArticleId({ articleId: this.currentArticleId }).then(
        (response) => {
          console.log("res", response.data);
          this.currentShareUserId = response.data.userId;
          this.showShareOptionsModal = true;
        }
      );
    },
    shareWithFriends() {
      this.showShareOptionsModal = false;

      this.searchFriends();
      this.searchGroups();
    },
    searchFriends() {
      var that = this;
      this.loading = true;
      GetFriendList()
        .then((response) => {
          console.log(response.data);
          that.friendsList = response.data; // 使用搜索结果更新列表
          // 在这里进行是否显示好友列表模态框的逻辑判断
          if (that.friendsList.length === 0) {
            // 如果好友列表为空，则弹窗提示用户先添加好友
            that.$message({
              message: "您现在没有好友，请添加好友",
              type: "error",
            });
          } else {
            // 有好友时显示好友列表模态框
            that.showFriendsListModal = true;
          }
        })
        .catch((error) => {
          console.error("获取好友出错:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchGroups() {
      var that = this;
      this.loading = true;
      getTmpGroupList({
        userId: 1,
      })
        .then((response) => {
          that.groupList = response.rows; // 使用搜索结果更新列表
          that.$store.state.msgContent.group = response.rows;
        })
        .catch((error) => {
          console.error("搜索好友出错:", error);
        });
    },
    /* http://localhost:8081/#/home/artdetail/606
       http://47.105.45.11:9000/kp-1/606/606.html
       线上：http://47.105.45.11/#/home/artdetail?aid=784&asource=%E9%9D%92%E6%98%A5%E5%B1%B1%E4%B8%9C
       http://localhost:8083/#/home/artdetail?aid=1019
    */
    getShareUrl(articleId, source, akpArticleLabels, acreateTime) {
      // 基础 URL，您可以根据需要更改此 URL

      const baseNewUrl = url.replace(/:\d+\/api$/, "") + "/#/home/";
      let isShareMode = true;
      let authorId = this.currentShareUserId;
      const shareUrl = `${baseNewUrl}artdetail?aid=${articleId}&authorId=${authorId}&isShareMode=${isShareMode}`;

      return shareUrl;
    },

    copyShareLink(articleId, source, labels, time) {
      // 定义新的基础URL
      const shareUrl = this.getShareUrl(articleId, source, labels, time);
      // 调用复制到剪贴板的函数
      this.copyToClipboardAsLink(
        "【知识阁-文章分享】 " + this.currentArticleTitle + " " + shareUrl
      );
    },
    // 这个函数会复制文本作为超链接到剪贴板
    // 注意：这种方法可能在某些环境下不起作用，因为它依赖于目标应用如何处理HTML内容
    copyToClipboardAsLink(text) {
      const tempInput = document.createElement("input");
      document.body.appendChild(tempInput);
      tempInput.value = text;
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      // 可选：显示一个提示，通知用户链接已复制
      this.$message({
        message: "分享链接已复制到剪贴板",
        type: "success",
      });
    },
    shareWithSelectedFriends() {
      if (
        this.selectedFriends.length === 0 &&
        this.selectedGroups.length === 0
      ) {
        this.$message({
          message: "请选择至少一个好友进行分享",
          type: "warning",
        });
        return;
      }

      this.selectedFriends.forEach((friend) => {
        this.sendLinkToFriend(friend); // 使用已有的发送链接方法
      });
      this.selectedGroups.forEach((group) => {
        this.sendLinkToGroup(group); // 使用已有的发送链接方法
      });
      this.$message({
        message: "已成功分享给好友聊天",
        type: "success",
      });

      // 分享后重置选中的好友列表
      this.selectedFriends = [];
      this.selectedGroups = [];
      // 可选：关闭好友列表模态框
      this.closeFriendsListModal();
    },
    convertUrlsToLinks(text) {
      // 使用正则表达式查找URL
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
    },
    sendLinkToFriend(friend) {
      // 发送链接给好友的逻辑
      // 构造要发送的数据
      // 定义新的基础URL
      const shareUrl = this.getShareUrl(
        this.currentArticleId,
        this.currentSource,
        this.currentLabels,
        this.currentCreateTime
      );
      /* let shareUrls = this.convertUrlsToLinks(shareUrl);
      "【知识阁-文章分享】" + this.currentArticleTitle + " " + 
      */
      sendSingleArticleMessage(
        shareUrl,
        this.userId,
        "【知识阁-文章分享】 " + this.currentArticleTitle + " ",
        friend.userId
      );
      const data = {
        articleId: this.currentArticleId,
        articleTitle: this.currentArticleTitle, // 当前文章标题
        friendName: friend.userName, // 好友的名字
        createTime: new Date().toISOString(), // 当前时间的 ISO 字符串
        receiveUid: friend.userId,
        sendName: this.userInfo.name,
      };
      insertShareHistroy(data)
        .then((response) => {
          this.$message({
            message: "分享好友成功",
            type: "success",
          });

          // 这里可以添加一些用户反馈，比如显示一个通知或者消息
        })
        .catch((error) => {
          // 处理错误
          console.error("发送链接失败:", error);
          // 这里可以添加错误处理，比如显示错误消息
        });
    },
    sendLinkToGroup(group) {
      // 发送链接给好友的逻辑
      // 构造要发送的数据
      // 定义新的基础URL
      const shareUrl = this.getShareUrl(
        this.currentArticleId,
        this.currentSource,
        this.currentLabels,
        this.currentCreateTime
      );
      /* let shareUrls = this.convertUrlsToLinks(shareUrl); */
      sendGroupArticleMessage(
        shareUrl,
        this.userId,
        "【知识阁-文章分享】 " + this.currentArticleTitle + " ",
        group.groupId
      );
      this.$message({
        message: "分享团队成功",
        type: "success",
      });
      //要把这个分享插进分享记录里
      const data = {
        articleId: this.currentArticleId,
        articleTitle: this.currentArticleTitle, // 当前文章标题
        createTime: new Date().toISOString(), // 当前时间的 ISO 字符串
        receiveGroupid: group.groupId,
        groupName: group.groupName, // 好友的名字
        sendName: this.userInfo.name,
      };
      insertShareHistroy(data)
        .then((response) => {
    
          // 处理响应
          // 这里可以添加一些用户反馈，比如显示一个通知或者消息
        })
        .catch((error) => {
          // 处理错误
          console.error("发送链接失败:", error);
          // 这里可以添加错误处理，比如显示错误消息
        });
    },
    closeShareOptionsModal() {
      this.showShareOptionsModal = false;
    },

    closeFriendsListModal() {
      this.showFriendsListModal = false;
    },

    exportFile(articleId, source, articleTitle) {
      console.log(articleId);
      this.downloadFileAsync(articleId, source, articleTitle);
    },
    exportFileLocal(articleId, source, articleTitle) {
      console.log(articleId);
      this.downloadFileLocalAsync(articleId, source, articleTitle);
      // loadingInstance.close(); // 关闭加载状态
    },
    async downloadFileAsync(articleId, source, articleTitle) {
      try {
        const loadingInstance = this.$loading({
          lock: true, // 是否锁定背景滚动，默认为 false
          text: "下载中", // 显示的文本内容
          spinner: "el-icon-loading", // 加载图标
          background: "rgba(255, 255, 255, 0.7)", // 遮罩层背景色
        });
        const response = await exportToLocalPdf({
          userId: this.userInfo.id,
          articleId: articleId,
        });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = source + "-"  +articleTitle + ".pdf";

        document.body.appendChild(downloadLink);
        downloadLink.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(downloadLink);

        loadingInstance.close(); // 关闭加载状态
      } catch (err) {
        console.error("Error downloading file:", err);
        loadingInstance.close(); // 关闭加载状态
      }
    },
    async downloadFileLocalAsync(articleId, source, articleTitle) {
      try {
        const loadingInstance = this.$loading({
          lock: true, // 是否锁定背景滚动，默认为 false
          text: "下载中", // 显示的文本内容
          spinner: "el-icon-loading", // 加载图标
          background: "rgba(255, 255, 255, 0.7)", // 遮罩层背景色
        });
        // 发起HTTP GET请求以获取后端文件数据
        const response = await exportToLocal({
          userId: this.userInfo.id,
          articleId: articleId,
        });

        console.log(response); // 确认response对象是否被正确地初始化
        if (response.headers["content-type"]) {
          console.log(response.data);

          // 获取后端传递的文件类型
          const contentType = response.headers["content-type"];

          // 创建一个Blob对象
          console.log(contentType);
          const blob = new Blob([response.data], {
            type: contentType,
          });

          // 创建一个虚拟的链接元素
          const link = document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.target = "_blank"; // 在新标签页中打开链接
          link.download = source + "-" + articleTitle; // 设置下载的文件名
          document.body.appendChild(link);

          // 触发点击事件来开始下载
          link.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);

          loadingInstance.close(); // 关闭加载状态
        }
      } catch (error) {
        console.error("下载文件时出错：", error);
        loadingInstance.close(); // 关闭加载状态
      }
    },
    deleteArt(articleId) {
      deleteArticle({
        userId: this.userInfo.id || 1,
        articleId: articleId,
      }).then((res) => {
        if (res.code === 200) {
          this.tpses(this.curSes);
        }
      });
    },
  },
};
</script>

<style>
.artmag_tip_noac {
  color: #707070 !important;
}

.artmag_artitem_btn_del_in {
  border: solid 1px #e45c49;
  padding-left: 6px;
  padding-right: 6px;
  color: #e45c49;
}

.artmag_artitem_btn_del_out {
  border: solid 1px #e45c49;
  padding: 2px;
  margin-left: 10px;
  cursor: pointer;
}

.artmag_artitem_btn_export_in {
  border: solid 1px #1399ff;
  padding-left: 6px;
  padding-right: 6px;
  color: #1399ff;
}

.artmag_artitem_btn_export_out {
  border: solid 1px #1399ff;
  padding: 2px;
  margin-left: 10px;
  cursor: pointer;
}

.artmag_artitem_btn_share_in {
  border: solid 1px #29d4b2;
  padding-left: 6px;
  padding-right: 6px;
  color: #29d4b2;
}

.artmag_artitem_btn_share_out {
  border: solid 1px #29d4b2;
  padding: 2px;
  margin-left: 10px;
  cursor: pointer;
}

.artmag_artitem_btn_detail_in {
  border: solid 1px #c39c61;
  padding-left: 6px;
  padding-right: 6px;
  color: #c39c61;
}

.artmag_artitem_btn_detail_out {
  border: solid 1px #c39c61;
  padding: 2px;
  margin-left: 10px;
  cursor: pointer;
}

.artmag_artitem_infor_right {
  display: flex;
  align-items: center;
}

.artmag_artitem_infor_time {
  color: #c39c61;
  font-size: 14px;
  margin-left: 35px;
}

.artmag_artitem_infor_sou {
  color: #808080;
  font-size: 14px;
}

.artmag_artitem_infor_tag {
  font-size: 14px;
  margin-left: 25px;
  color: #ffffff;
  border: solid 1px #000000;
  font-weight: 700;
  padding: 5px;
  background-color: #0187ea;
}

.artmag_artitem_infor_left {
  display: flex;
  align-items: center;
}

.artmag_artitem_infor {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.artmag_artitem_con {
  color: #333333;
  font-size: 18px;
  cursor: pointer;
}

.artmag_artitem {
  padding: 12px;
  border-bottom: solid 1px #cccccc;
}

.artmag_tp_item_active {
  color: #2683be !important;
  border-bottom: solid 1px #2683be;
}

.artmag_tp_item {
  color: #262626;
  font-size: 18px;
  font-weight: 550;
  margin-right: 20px;
  cursor: pointer;
  padding-bottom: 4px;
}

.artmag_tp_con {
  display: flex;
  align-items: center;
  background-color: #dedede;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: solid 1px #cccccc;
}

.artmag_bgcon {
  margin-top: 30px;
  border: solid 1px #dedede;
}

.artmag_start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 99px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 220px;
  color: white;
  border: none;
  cursor: pointer;
}

.artmag_add_in_con1 {
  width: 220px;
}

.artmag_el-dropdown-link {
  border: solid 2px #0187ea;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 200px;
  font-size: 18px;
}

.argmag_add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.argmag_add_in::placeholder {
  font-size: 18px;
  color: #999999;
}

.argmag_add_in:focus {
  outline: none;
}

.artmag_txt_label {
  color: #333333;
  font-size: 15px;
  font-weight: 550;
}

.artmag_line_con {
  display: flex;
  align-items: center;
}

.artmag_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.artmag_top_bar {
  display: flex;
  align-items: center;
}

/* 分享选项弹窗样式 */
.share-options-modal {
  background-color: #6878a7;
  border: 1px solid #e0e0e0;
  padding: 15px;
  width: 350px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.share-option {
  background-color: #ffffff; /* 白色背景 */
  border: 1px solid #dcdcdc; /* 边框 */
  padding: 10px 20px;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.share-option:hover {
  background-color: #e6e6e6; /* 悬停时的背景色 */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); /* 悬停时的阴影 */
}

/* 好友和团对的两个div */
.list-section .section-title {
  text-align: center;
  color: red;
  background-color: orange;
  border-radius: 8px;
  margin: 10px 0;
  padding: 5px;
}

.list-container {
  max-height: 200px; /* 可以根据需要调整固定高度 */
  overflow-y: auto;
  margin-bottom: 10px;
}

/* 添加滚动条样式 */
.list-container::-webkit-scrollbar {
  width: 8px;
}

.list-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.list-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.list-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* 好友列表弹窗样式 */
.friends-list-modal {
  background-color: white;
  border: 1px solid #ccc;
  padding: 20px;
  width: 300px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1); /* 增加阴影以增强层次感 */
  text-align: center;
}

.friend-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.fri_img {
  width: 40px;
  height: 40px;
  border-radius: 20px; /* 圆形头像 */
  margin-right: 10px;
}

.friend_name {
  margin-right: 10px;
}

.friend-item button {
  border: 1px solid #29d4b2;
  background-color: #29d4b2;
  color: white;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px; /* 圆角按钮 */
}

/* Container for the buttons */
.friends-list-modal-actions {
  display: flex;
  justify-content: space-between; /* Space out buttons */
  align-items: center;
  margin-top: 20px; /* Add space above the button row */
}

/* Style for the one-click share button */
button.shareWithSelectedFriends {
  background-color: #4caf50; /* Green background */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px; /* Rounded corners for the button */
  cursor: pointer;
  flex-grow: 1; /* Allows the button to grow and fill space */
  margin-right: 10px; /* Space between buttons */
}

/* Style for the cancel option */
.close-option {
  background-color: #f44336; /* Red background */
  color: white;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 5px; /* Consistent rounded corners */
  flex-grow: 1; /* Allows the div to grow and fill space */
  text-align: center;
}

/* Hover effects for interactivity */
button.shareWithSelectedFriends:hover,
.close-option:hover {
  opacity: 0.8;
}
</style>
